/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsMapHeader = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsMapHeader = $.extend(this, window.PXUTheme.getSectionData($section));
    this.element = $section[0];

    const map = document.querySelector(".Section--map");
    if (map) {
      document.addEventListener("googleScripts:loaded", this.handleInput.bind(this));
    }
    this.delegateElement = new domDelegate.Delegate($section[0]);

    this.delegateElement.on('click', '.Main.button', this.scrollToMap.bind(this), true);
    this.delegateElement.on('submit', '.stockist-search-form', this.scrollToMap.bind(this), true);
    this.delegateElement.on('click', '[data-get-location]', this.getLocation.bind(this));
    
  },
  handleInput() {
    const form = document.querySelector(".stockist-search-form");
    let $this = this;

    function relocateInput() {
      const form = document.querySelector(".stockist-search-form");
      const container = $this.element.querySelector(".Section--map_header--content--form");

      // Main Button 
      const findButton = form.querySelector('button');
      findButton.classList.add("Main", "button");
      findButton.innerHTML = $this.findButton;

      // Wrap input field
      const input = form.querySelector('input');
      const wrapper = document.createElement('div');
      wrapper.classList.add("input_wrapper");
      const tempParent = form.querySelector('.stockist-query-entry');
      tempParent.insertBefore(wrapper,input);
      wrapper.append(input);

      // Find My Geolocation Button
      const locationButton = document.createElement("button");
      locationButton.classList.add('button', 'GetLocation');
      locationButton.setAttribute("data-get-location", "");
      locationButton.innerHTML = $this.locationIcon;
      wrapper.append(locationButton);

      // Append to container
      container.insertBefore(form, container.querySelector(".button"));
      container.style.opacity = 1;
    }

    if (form) {
      relocateInput()
    } else {
      function callback(mutations) {      
        for (let mutation of mutations) {
          if (mutation.type === 'childList' && mutation.target.classList.contains("stockist-search-form")) {
            observer.disconnect();
            relocateInput();
          }
        }
      }
      
      const target = document.querySelector(".Section--map");
      const observer = new MutationObserver(callback);
      observer.observe(target, {
        childList: true,
        subtree: true
      });
    }
  },
  scrollToMap() {
    setTimeout(()=>{
      const target = document.querySelector(".stockist-map-inner");
      const header = document.querySelector(".jsHeader");
      const subHeader = document.querySelector(".jsSubheaderBar");
      const correction = 5 + (header.offsetHeight || 0) + (subHeader.offsetHeight || 0)
      window.PXUTheme.scrollToTop(target, correction)
    }, 1000)
  },
  getLocation(event) {
    event.preventDefault();
    let response = window.__stockist_trigger_geolocation();
    let $this = this;
    const getGoogleDAta = setInterval(() => {
      if (response._state === 1 ) {
        clearInterval(getGoogleDAta);
        $this.scrollToMap();
      } else if (response._state === 2) {
        clearInterval(getGoogleDAta);
        let message = document.createElement("p");
        message.textContent = "Cannot get your Location. Check your geolocation settings and try again.";
        message.classList.add("warning");
        let target = document.querySelector(".Section--map_header--content--form");
        target.insertBefore(message, document.querySelector(".stockist-search-form"));
        setTimeout(() => {
          $(message).fadeOut(500);
        }, 12000)
      }
    }, 100);
  },
  unload: function($section) {
  }
}

/******/ })()
;